<template>
  <v-app>
    <v-main>
      <v-toolbar dense dark>
        <v-toolbar-title style="width: 800px">SZKP-Békás Regisztrációs Iroda CRM</v-toolbar-title>
        <v-img
              src="@/assets/pic.png"
              height="45"
              width="200"
              class="grey darken-4"
            ></v-img>
        <v-tabs @change="handleChange" v-model="tab" right>
          <v-tab @click="toClients">Ügyfelek</v-tab>
          <v-tab @click="toLogout">Kijelentkezés</v-tab>
        </v-tabs>
      </v-toolbar>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  components: {

  },
  async mounted() {
    const response = await fetch('/.auth/me');
    const payload = await response.json();
    const { clientPrincipal } = payload;
    this.admin = clientPrincipal.userRoles.find((role) => role == "administrator");
  },
  created() {
    this.tab = sessionStorage.getItem('key');
  },
  methods: {
    handleChange(index) {
      sessionStorage.setItem('key', index);
    },
    toClients() {
      this.$router.push("/clients").catch(() => { })
      window.location.reload();
    },
    toAdmin() {
      this.$router.push("/admin").catch(() => { })
      window.location.reload();
    },
    toLogout() {
      this.$router.push("/logout").catch(() => { })
      window.location.reload();
    },
  },

  data: () => ({
    admin: null,
    tab: null
  }),
};
</script>

<style scoped>
.v-tabs {
  float: right !important;
}

.v-tab {
  text-transform: none !important;
  text-decoration: none !important;
}
</style>